import { Controller } from "stimulus";

export default class extends Controller {

  connect() {
    this.element.addEventListener('click', this.closeModal.bind(this));
  }

  closeModal() {
    const modal = this.element.closest('.modal.fv-modal-stack.show');

    if (!!modal) {
      $(modal).modal('hide');
    }
  }
}